import script from "./indexbuy.vue?vue&type=script&setup=true&lang=js"
export * from "./indexbuy.vue?vue&type=script&setup=true&lang=js"

import "./indexbuy.vue?vue&type=style&index=0&id=eae86566&lang=css"

const __exports__ = script;

export default __exports__